import type { HomeStats } from 'types/api/stats';

import { HOMEPAGE_STATS } from 'stubs/stats';

import useApiQuery from './useApiQuery';

/*
 * Created Date: October 13th 2025, 7:03:24 pm
 * Author: zhoupengcheng
 * -----
 * Last Modified: October 13th 2025, 7:03:24 pm
 */
export default function useStats(queryOptions: any = {}) {
  const res = useApiQuery('stats', {
    queryOptions: {
      refetchOnMount: false,
      placeholderData: HOMEPAGE_STATS,
      ...queryOptions,
    },
  });

  const prices = res.data?.gas_prices;

  const { average, fast, slow } = prices || {};

  const data = {
    ...res.data,
    gas_prices: {
      average: {
        // fiat_price: average,
        price: average,
        time: 12283,
        base_fee: 2.22222,
        priority_fee: 12.424242,
      },
      fast: {
        // fiat_price: fast,
        price: fast,
        time: 12283,
        base_fee: 2.22222,
        priority_fee: 12.424242,
      },
      slow: {
        // fiat_price: slow,
        price: slow,
        time: 12283,
        base_fee: 2.22222,
        priority_fee: 12.424242,
      },
    },
  } as HomeStats;

  return { ...res, data };
}
